import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './modules/auth/AuthContext';
import { SocialProvider } from './modules/social/SocialContext';
import './index.css';

console.log('React version:', React.version);

// Montagem direta
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <SocialProvider>
        <App />
      </SocialProvider>
    </AuthProvider>
  </React.StrictMode>
);